import { render, staticRenderFns } from "./ButtonNext.vue?vue&type=template&id=37147673&"
import script from "./ButtonNext.vue?vue&type=script&lang=js&"
export * from "./ButtonNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports